import { Box, Stack, Typography } from '@mui/material';
import { RemoveItemIcon } from './icons';

export const DeletedItemBanner: React.FC<{
  text: string;
  undeleteLabel?: string;
  onUndelete?: () => void;
}> = ({ text, undeleteLabel, onUndelete }) => {
  return (
    <Box
      sx={{
        padding: '1rem',
        backgroundColor: (theme) => theme.palette.error.main,
        color: (theme) => theme.palette.error.contrastText,
        borderRadius: '4px',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <RemoveItemIcon />
        <Typography>{text}</Typography>
        {onUndelete && undeleteLabel && (
          <Box
            component="span"
            onClick={onUndelete}
            sx={{ textDecoration: 'underline', cursor: 'pointer', marginLeft: '0.5rem' }}
          >
            {undeleteLabel}
          </Box>
        )}
      </Stack>
    </Box>
  );
};
